import React from "react";
import { anatomyConstants } from "../../../constants/anatomyConstants";

const StentModal = ({
    upperDiameter, setUpperDiameter,
    innerDiameter, setInnerDiameter,
    lowerDiameter, setLowerDiameter,
    height, setHeight,
    transformMode, setTransformMode,
    updateStentInScene,
    downloadStentSTL,
    closeModal,
    isMobile,
}) => {
    const isMobilePortrait =
        isMobile &&
        typeof window !== "undefined" &&
        window.innerWidth < window.innerHeight;

    return (
        <div
            className={`absolute ${isMobilePortrait ? "bottom-20 left-2 right-2" : "bottom-1 left-28"
                } flex flex-col space-y-3 p-4 bg-white text-gray-800 rounded-lg shadow-xl max-w-sm z-20`}
            style={{
                "--main-color": anatomyConstants.mainColor,
                "--main-color-bold": anatomyConstants.mainColorBold,
            }}
        >
            <div className="flex justify-between items-center pb-2 border-b border-gray-200">
                <h3 className="font-semibold text-gray-800">Stent Oluştur</h3>
                <button
                    onClick={(e) => {
                        e.stopPropagation();
                        closeModal();
                    }}
                    aria-label="Close"
                    className="w-6 h-6 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center text-gray-700"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        className="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                    >
                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>

            <div className="grid grid-cols-2 gap-3 text-sm">
                <div className="flex flex-col space-y-1">
                    <label className="font-medium text-gray-600">Üst Çap (mm)</label>
                    <input
                        type="number"
                        min="0.1"
                        step="0.1"
                        value={upperDiameter}
                        onChange={(e) => setUpperDiameter(parseFloat(e.target.value) || 0)}
                        className="border border-gray-300 rounded px-2 py-1 outline-none focus:border-[var(--main-color)]"
                    />
                </div>
                <div className="flex flex-col space-y-1">
                    <label className="font-medium text-gray-600">Alt Çap (mm)</label>
                    <input
                        type="number"
                        min="0.1"
                        step="0.1"
                        value={lowerDiameter}
                        onChange={(e) => setLowerDiameter(parseFloat(e.target.value) || 0)}
                        className="border border-gray-300 rounded px-2 py-1 outline-none focus:border-[var(--main-color)]"
                    />
                </div>
                <div className="flex flex-col space-y-1">
                    <label className="font-medium text-gray-600">İç Çap (mm)</label>
                    <input
                        type="number"
                        min="0.1"
                        step="0.1"
                        value={innerDiameter}
                        onChange={(e) => setInnerDiameter(parseFloat(e.target.value) || 0)}
                        className="border border-gray-300 rounded px-2 py-1 outline-none focus:border-[var(--main-color)]"
                    />
                </div>
                <div className="flex flex-col space-y-1">
                    <label className="font-medium text-gray-600">Yükseklik (mm)</label>
                    <input
                        type="number"
                        min="0.1"
                        step="0.1"
                        value={height}
                        onChange={(e) => setHeight(parseFloat(e.target.value) || 0)}
                        className="border border-gray-300 rounded px-2 py-1 outline-none focus:border-[var(--main-color)]"
                    />
                </div>
            </div>

            <div className="flex space-x-2 pt-2 border-b border-gray-200 pb-3">
                <button
                    onClick={updateStentInScene}
                    className="flex-1 bg-[var(--main-color)] text-white py-1.5 rounded font-medium hover:bg-[var(--main-color-bold)] transition-colors"
                >
                    Göster / Güncelle
                </button>
            </div>

            <div className="flex flex-col space-y-2 pt-1">
                <span className="text-sm font-medium text-gray-700">3 Boyutlu Hizalama</span>
                <div className="flex bg-gray-100 p-1 rounded-lg">
                    <button
                        onClick={() => setTransformMode("off")}
                        className={`flex-1 py-1 text-xs font-medium rounded-md transition-colors ${transformMode === "off" ? "bg-white shadow-sm text-gray-800" : "text-gray-500 hover:text-gray-700"
                            }`}
                    >
                        Kapalı
                    </button>
                    <button
                        onClick={() => setTransformMode("translate")}
                        className={`flex-1 py-1 text-xs font-medium rounded-md transition-colors ${transformMode === "translate" ? "bg-[var(--main-color)] text-white shadow-sm" : "text-gray-500 hover:text-gray-700"
                            }`}
                    >
                        Taşı
                    </button>
                    <button
                        onClick={() => setTransformMode("rotate")}
                        className={`flex-1 py-1 text-xs font-medium rounded-md transition-colors ${transformMode === "rotate" ? "bg-[var(--main-color)] text-white shadow-sm" : "text-gray-500 hover:text-gray-700"
                            }`}
                    >
                        Döndür
                    </button>
                </div>
                {transformMode !== "off" && (
                    <p className="text-[11px] text-gray-500 leading-tight">
                        * Ekranda çıkan {transformMode === "translate" ? "okları (kırmızı, yeşil, mavi)" : "halkaları"} çekerek stenti uzayda hareket ettirebilirsiniz. Kalbe/damara girmesi için serbesttir.
                    </p>
                )}
            </div>

            <div className="pt-2">
                <button
                    onClick={downloadStentSTL}
                    className="w-full bg-gray-800 text-white py-1.5 rounded font-medium hover:bg-gray-900 transition-colors text-sm"
                >
                    STL Olarak İndir
                </button>
            </div>

        </div>
    );
};

export default StentModal;
